<div>
  <table mat-table [dataSource]="selectedJobs">
    <ng-container matColumnDef="displayName">
      <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Display Name' | translate }}</th>
      <td mat-cell *matCellDef="let element; index as i">{{ element.displayName }}</td>
    </ng-container>

    <ng-container matColumnDef="actions">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row; let rowIndex = index">
        <button
          type="button"
          mat-icon-button
          color="warn"
          (click)="removeJobFromSelection(rowIndex)"
          matTooltip="Delete"
          matTooltipPosition="left"
        >
          <fa-icon icon="trash"></fa-icon>
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="columnsToDisplay" class="first-row"></tr>
    <tr mat-row *matRowDef="let selectedJobs; columns: columnsToDisplay"></tr>
  </table>
</div>
